import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'semantic-ui-less/semantic.less';
import i18n from "./i18n";
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from "react-i18next";
import HttpsRedirect from 'react-https-redirect';

import AppRouter from './AppRouter'; // <-- nieuw

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <I18nextProvider i18n={i18n}>
    <BrowserRouter>
      <HttpsRedirect>
        <AppRouter />
      </HttpsRedirect>
    </BrowserRouter>
  </I18nextProvider>
);

serviceWorker.unregister();